import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-global" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "flex flex-row-reverse" }

import { computed, onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import VueTableLite from "vue3-table-lite/ts";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { Button } from "@/components/common";
import { EntityApprovalActions } from "@/store/modules/entityApproval/actions";
import { EntityApprovalGetters } from "@/store/modules/entityApproval/getters";
import { t } from "@/i18n";
import { isEntityApprovalId } from "@/types/common/entityApproval/EntityApproval";
import {
  getEntityApprovalActionLabel,
  getEntityApprovalStatusLabel,
  getEntityApprovalTypeLabel,
} from "@/utils/labels";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const dataProvider = computed(
  () => store.getters[EntityApprovalGetters.GET_DATA_PROVIDER]
);
const items = computed(() => dataProvider.value.items);
const pager = computed(() => dataProvider.value.pager);

const table = reactive({
  isLoading: false,
  columns: [
    {
      label: t("entityApproval.entityType"),
      field: "entityType",
      sortable: false,
    },
    {
      label: t("entityApproval.actionType"),
      field: "actionType",
      sortable: false,
    },
    {
      label: t("entityApproval.requester"),
      field: "requesterId",
      sortable: false,
    },
    {
      label: t("entityApproval.approvalStatus"),
      field: "status",
      sortable: false,
    },
    { label: "", field: "action", sortable: false },
  ],
  rows: items,
  totalRecordCount: 0,
});

const loadList = async (page = 1) => {
  table.isLoading = true;
  try {
    await store.dispatch(EntityApprovalActions.FETCH_DATA_PROVIDER, { page });
  } finally {
    table.isLoading = false;
  }
};

const getPage = async (page: number) => {
  await loadList(page);
};

onMounted(async () => {
  if (route.query.approvalId) {
    const id = route.query.approvalId;
    if (isEntityApprovalId(id)) {
      await router.replace({ name: "EntityApprovalDetails", params: { id } });
      return;
    }
  }
  await loadList(1);
});

const openDetails = (id: string) => {
  router.push({ name: "EntityApprovalDetails", params: { id } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("entityApproval.title")), 1)
    ]),
    _createVNode(_unref(VueTableLite), {
      "data-pagination-scroll-anchor": "",
      class: "mt-6",
      "is-slot-mode": true,
      "is-loading": _unref(table).isLoading,
      columns: _unref(table).columns,
      rows: _unref(table).rows,
      total: _unref(table).totalRecordCount,
      sortable: false,
      "is-hide-paging": true,
      messages: { noDataAvailable: _unref(t)('common.noData') }
    }, {
      entityType: _withCtx((data) => [
        _createTextVNode(_toDisplayString(_unref(getEntityApprovalTypeLabel)(data.value.entityType)), 1)
      ]),
      actionType: _withCtx((data) => [
        _createTextVNode(_toDisplayString(_unref(getEntityApprovalActionLabel)(data.value.actionType)), 1)
      ]),
      requesterId: _withCtx((data) => [
        _createTextVNode(_toDisplayString(data.value.requesterName || data.value.requesterId), 1)
      ]),
      status: _withCtx((data) => [
        _createTextVNode(_toDisplayString(_unref(getEntityApprovalStatusLabel)(data.value.status)), 1)
      ]),
      action: _withCtx((data) => [
        _createVNode(_unref(Button), {
          variant: "soft-primary",
          onClick: ($event: any) => (openDetails(data.value.id))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.details")), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["is-loading", "columns", "rows", "total", "messages"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(TablePagination, {
        current: _unref(pager).currentPage,
        "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_unref(pager).currentPage) = $event)),
        "total-pages": _unref(pager).totalPages,
        "onUpdate:total-pages": _cache[1] || (_cache[1] = ($event: any) => ((_unref(pager).totalPages) = $event)),
        "start-page": _unref(pager).startPage,
        "end-page": _unref(pager).endPage,
        onPageChanged: getPage
      }, null, 8, ["current", "total-pages", "start-page", "end-page"])
    ])
  ]))
}
}

})